import { render, staticRenderFns } from "./AddEditInventory.vue?vue&type=template&id=5ce50b46&"
import script from "./AddEditInventory.vue?vue&type=script&lang=js&"
export * from "./AddEditInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports